// @ts-nocheck
/* eslint-disable */
/* This file was generated by Unframer for Framer project 87f9c755347dad76 "VastiPost", do not edit manually */
"use client";

/**
 * @typedef Locale
 * string
 */

/**
 * @typedef {{
 * children?: React.ReactNode
 * locale?: Locale
 * style?: React.CSSProperties
 * className?: string
 * id?: string
 * ref?: any
 * width?: any
 * height?: any
 * layoutId?: string
 * variant?: 'ConfirmationRequest' | 'Confirmed' // Variant
 * question?: string // Question
 * message?: string // Message
 * exitClick?: Function // Exit Click
 * confirmationColor?: string // ConfirmationColor
 * dECLINETEXT?: string // DECLINE TEXT
 * cONFIRMATIONTEXT?: string // CONFIRMATIONTEXT
}} Props

 */
import { routes } from "./chunks/chunk-QHTAN6EJ.js";

// virtual:confirmation-request
import { Fragment as Fragment2 } from "react";
import { ContextProviders } from "unframer";

// /:https://framerusercontent.com/modules/xhXoJeFLcDZMMwfCxpnD/CCC7jdVQEfJGNRxNlIHN/PMvn2toMA.js
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {
	addFonts,
	addPropertyControls,
	ControlType,
	cx,
	RichText,
	SVG,
	useActiveVariantCallback,
	useComponentViewport,
	useLocaleInfo,
	useVariantState,
	withCSS,
} from "unframer";
import { LayoutGroup, motion, MotionConfigContext } from "unframer";
import * as React from "react";
import { useRef } from "react";
var cycleOrder = ["ono3D8Lsa", "ZUd9LxhGg"];
var serializationHash = "framer-qHULT";
var variantClassNames = {
	ono3D8Lsa: "framer-v-xwvekh",
	ZUd9LxhGg: "framer-v-1wp5uty",
};
function addPropertyOverrides(overrides, ...variants) {
	const nextOverrides = {};
	variants?.forEach(
		(variant) => variant && Object.assign(nextOverrides, overrides[variant]),
	);
	return nextOverrides;
}
var transition1 = {
	bounce: 0.2,
	delay: 0,
	duration: 0.4,
	type: "spring",
};
var Transition = ({ value, children }) => {
	const config = React.useContext(MotionConfigContext);
	const transition = value ?? config.transition;
	const contextValue = React.useMemo(
		() => ({
			...config,
			transition,
		}),
		[JSON.stringify(transition)],
	);
	return (
		<MotionConfigContext.Provider value={contextValue}>
			{children}
		</MotionConfigContext.Provider>
	);
};
var Variants = motion.create(React.Fragment);
var humanReadableVariantMap = {
	ConfirmationRequest: "ono3D8Lsa",
	Confirmed: "ZUd9LxhGg",
};
var getProps = ({
	confirmationColor,
	cONFIRMATIONTEXT,
	dECLINETEXT,
	exitClick,
	height,
	id,
	message,
	question,
	width,
	...props
}) => {
	return {
		...props,
		G7QWmFrxx: exitClick ?? props.G7QWmFrxx,
		jhL6rJVje: cONFIRMATIONTEXT ?? props.jhL6rJVje ?? "YES",
		PC5Ghwrec: confirmationColor ?? props.PC5Ghwrec ?? "rgb(255, 149, 140)",
		Rn0tbIBHJ: message ?? props.Rn0tbIBHJ ?? "Upload Cancelled",
		TFHZ_QdnQ:
			question ??
			props.TFHZ_QdnQ ??
			"Are you sure you would like to cancel this scheduled upload?",
		variant:
			humanReadableVariantMap[props.variant] ?? props.variant ?? "ono3D8Lsa",
		WnTLDTmKT: dECLINETEXT ?? props.WnTLDTmKT ?? "NO",
	};
};
var createLayoutDependency = (props, variants) => {
	if (props.layoutDependency)
		return variants.join("-") + props.layoutDependency;
	return variants.join("-");
};
var Component = /* @__PURE__ */ React.forwardRef(function (props, ref) {
	const fallbackRef = useRef(null);
	const refBinding = ref ?? fallbackRef;
	const defaultLayoutId = React.useId();
	const { activeLocale, setLocale } = useLocaleInfo();
	const componentViewport = useComponentViewport();
	const {
		style,
		className,
		layoutId,
		variant,
		TFHZ_QdnQ: TFHZ_QdnQ2,
		Rn0tbIBHJ: Rn0tbIBHJ2,
		G7QWmFrxx: G7QWmFrxx2,
		PC5Ghwrec: PC5Ghwrec2,
		WnTLDTmKT: WnTLDTmKT2,
		jhL6rJVje: jhL6rJVje2,
		...restProps
	} = getProps(props);
	const {
		baseVariant,
		classNames,
		clearLoadingGesture,
		gestureHandlers,
		gestureVariant,
		isLoading,
		setGestureState,
		setVariant,
		variants,
	} = useVariantState({
		cycleOrder,
		defaultVariant: "ono3D8Lsa",
		ref: refBinding,
		variant,
		variantClassNames,
	});
	const layoutDependency = createLayoutDependency(props, variants);
	const { activeVariantCallback, delay } =
		useActiveVariantCallback(baseVariant);
	const onTapd8k8ka = activeVariantCallback(async (...args) => {
		setVariant("ZUd9LxhGg");
	});
	const onTapxyf9sh = activeVariantCallback(async (...args) => {
		if (G7QWmFrxx2) {
			const res = await G7QWmFrxx2(...args);
			if (res === false) return false;
		}
	});
	const sharedStyleClassNames = [];
	const scopingClassNames = cx(serializationHash, ...sharedStyleClassNames);
	const isDisplayed = () => {
		if (baseVariant === "ZUd9LxhGg") return false;
		return true;
	};
	return (
		<LayoutGroup id={layoutId ?? defaultLayoutId}>
			<Variants animate={variants} initial={false}>
				<Transition value={transition1}>
					<motion.div
						{...restProps}
						{...gestureHandlers}
						className={cx(
							scopingClassNames,
							"framer-xwvekh",
							className,
							classNames,
						)}
						data-framer-name={"ConfirmationRequest"}
						layoutDependency={layoutDependency}
						layoutId={"ono3D8Lsa"}
						ref={refBinding}
						style={{
							backgroundColor:
								"var(--token-71a032bc-188d-4e0d-a935-460c80d29cf9, rgb(249, 250, 251))",
							borderBottomLeftRadius: 10,
							borderBottomRightRadius: 10,
							borderTopLeftRadius: 10,
							borderTopRightRadius: 10,
							...style,
						}}
						{...addPropertyOverrides(
							{
								ZUd9LxhGg: {
									"data-framer-name": "Confirmed",
								},
							},
							baseVariant,
							gestureVariant,
						)}
					>
						<RichText
							__fromCanvasComponent={true}
							className={"framer-1swgr0j"}
							data-framer-name={"ConfirmationRequestMessage"}
							fonts={["Inter"]}
							layoutDependency={layoutDependency}
							layoutId={"jRwifJdfN"}
							style={{
								"--extracted-1w3ko1f": "rgb(255, 149, 140)",
								"--extracted-r6o4lv": "rgb(46, 46, 46)",
								"--framer-paragraph-spacing": "0px",
							}}
							text={TFHZ_QdnQ2}
							verticalAlignment={"center"}
							withExternalLayout={true}
							{...addPropertyOverrides(
								{
									ZUd9LxhGg: {
										children: (
											<React.Fragment>
												<motion.p
													style={{
														"--framer-text-alignment": "center",
														"--framer-text-color":
															"var(--extracted-r6o4lv, rgb(46, 46, 46))",
													}}
												>
													{"Scheduled upload canceled."}
												</motion.p>
											</React.Fragment>
										),
										text: Rn0tbIBHJ2,
									},
								},
								baseVariant,
								gestureVariant,
							)}
						>
							<React.Fragment>
								<motion.p
									style={{
										"--framer-text-alignment": "center",
										"--framer-text-color":
											"var(--extracted-r6o4lv, rgb(46, 46, 46))",
									}}
								>
									{"Are you sure you would like to "}
									<motion.span
										style={{
											"--framer-text-color":
												"var(--extracted-1w3ko1f, rgb(255, 149, 140))",
											"--framer-text-decoration": "underline",
										}}
									>
										{"cancel"}
									</motion.span>
									{" this scheduled upload?"}
								</motion.p>
							</React.Fragment>
						</RichText>
						{isDisplayed() && (
							<motion.div
								className={"framer-19og62n"}
								data-framer-name={"ConfirmationButtons"}
								layoutDependency={layoutDependency}
								layoutId={"HU6f9YoEL"}
							>
								<motion.div
									className={"framer-zs2q9t"}
									data-framer-name={"ConfirmationRequestDividers"}
									layoutDependency={layoutDependency}
									layoutId={"fNrCPMLqv"}
								>
									<SVG
										className={"framer-ru6q8k"}
										data-framer-name={"Horizontal Line"}
										fill={"rgba(0,0,0,1)"}
										intrinsicHeight={3}
										intrinsicWidth={206}
										layoutDependency={layoutDependency}
										layoutId={"HivX0zbX1"}
										svg={
											'<svg width="206" height="3" viewBox="-1 -1 206 3" fill="none" xmlns="http://www.w3.org/2000/svg">\n<line x1="-4.37114e-08" y1="0.5" x2="204" y2="0.499982" stroke="#EDEFF2"/>\n</svg>\n'
										}
										withExternalLayout={true}
									/>
									<SVG
										className={"framer-1q40spg"}
										data-framer-name={"Vertical Line"}
										fill={"rgba(0,0,0,1)"}
										intrinsicHeight={52}
										intrinsicWidth={3}
										layoutDependency={layoutDependency}
										layoutId={"OaKwP2Ivw"}
										svg={
											'<svg width="3" height="52" viewBox="-1 -1 3 52" fill="none" xmlns="http://www.w3.org/2000/svg">\n<line x1="0.5" y1="-1.70474e-08" x2="0.500002" y2="50" stroke="#EDEFF2"/>\n</svg>\n'
										}
										withExternalLayout={true}
									/>
								</motion.div>
								<RichText
									__fromCanvasComponent={true}
									className={"framer-18hh2ca"}
									data-framer-name={"ConfirmationRequestYES"}
									data-highlight={true}
									fonts={["Inter-SemiBold"]}
									layoutDependency={layoutDependency}
									layoutId={"qUq6kM5zK"}
									onTap={onTapd8k8ka}
									style={{
										"--extracted-r6o4lv":
											"var(--variable-reference-PC5Ghwrec-PMvn2toMA)",
										"--framer-paragraph-spacing": "0px",
										"--variable-reference-PC5Ghwrec-PMvn2toMA": PC5Ghwrec2,
									}}
									text={jhL6rJVje2}
									verticalAlignment={"center"}
									withExternalLayout={true}
								>
									<React.Fragment>
										<motion.p
											style={{
												"--font-selector": "SW50ZXItU2VtaUJvbGQ=",
												"--framer-font-size": "20px",
												"--framer-font-weight": "600",
												"--framer-text-alignment": "center",
												"--framer-text-color":
													"var(--extracted-r6o4lv, var(--variable-reference-PC5Ghwrec-PMvn2toMA))",
												"--framer-text-decoration": "underline",
											}}
										>
											{"YES"}
										</motion.p>
									</React.Fragment>
								</RichText>
								<RichText
									__fromCanvasComponent={true}
									className={"framer-1m2bqkz"}
									data-framer-name={"ConfirmationRequestNO"}
									data-highlight={true}
									fonts={["Inter-SemiBold"]}
									layoutDependency={layoutDependency}
									layoutId={"VXzIlam5A"}
									onTap={onTapxyf9sh}
									style={{
										"--extracted-r6o4lv": "rgb(46, 46, 46)",
										"--framer-paragraph-spacing": "0px",
									}}
									text={WnTLDTmKT2}
									verticalAlignment={"center"}
									withExternalLayout={true}
								>
									<React.Fragment>
										<motion.p
											style={{
												"--font-selector": "SW50ZXItU2VtaUJvbGQ=",
												"--framer-font-size": "20px",
												"--framer-font-weight": "600",
												"--framer-text-alignment": "center",
												"--framer-text-color":
													"var(--extracted-r6o4lv, rgb(46, 46, 46))",
												"--framer-text-decoration": "underline",
											}}
										>
											{"NO"}
										</motion.p>
									</React.Fragment>
								</RichText>
							</motion.div>
						)}
					</motion.div>
				</Transition>
			</Variants>
		</LayoutGroup>
	);
});
var css = [
	"@supports (aspect-ratio: 1) { body { --framer-aspect-ratio-supported: auto; } }",
	".framer-qHULT.framer-wg775k, .framer-qHULT .framer-wg775k { display: block; }",
	".framer-qHULT.framer-xwvekh { align-content: center; align-items: center; display: flex; flex-direction: column; flex-wrap: nowrap; gap: 10px; height: min-content; justify-content: center; min-height: 150px; overflow: hidden; padding: 15px 0px 5px 0px; position: relative; width: 204px; will-change: var(--framer-will-change-override, transform); }",
	".framer-qHULT .framer-1swgr0j { flex: none; height: auto; position: relative; white-space: pre-wrap; width: 89%; word-break: break-word; word-wrap: break-word; }",
	".framer-qHULT .framer-19og62n { flex: none; height: 53px; overflow: visible; position: relative; width: 100%; }",
	".framer-qHULT .framer-zs2q9t { bottom: -10px; flex: none; left: 0px; overflow: visible; position: absolute; right: 0px; top: 0px; }",
	".framer-qHULT .framer-ru6q8k { flex: none; height: 3px; left: calc(50.00000000000002% - 109.80392156862746% / 2); position: absolute; top: 0px; width: 110%; }",
	".framer-qHULT .framer-1q40spg { flex: none; height: 130%; left: calc(50.00000000000002% - 3px / 2); position: absolute; top: 0px; width: 3px; }",
	".framer-qHULT .framer-18hh2ca { bottom: -7px; cursor: pointer; flex: none; height: 59px; left: 1px; position: absolute; white-space: pre-wrap; width: 102px; word-break: break-word; word-wrap: break-word; }",
	".framer-qHULT .framer-1m2bqkz { bottom: -7px; cursor: pointer; flex: none; height: 59px; position: absolute; right: 1px; white-space: pre-wrap; width: 101px; word-break: break-word; word-wrap: break-word; }",
	".framer-qHULT.framer-v-1wp5uty.framer-xwvekh { padding: 0px 0px 5px 0px; }",
];
var FramerPMvn2toMA = withCSS(Component, css, "framer-qHULT");
var stdin_default = FramerPMvn2toMA;
FramerPMvn2toMA.displayName = "ConfirmationRequest";
FramerPMvn2toMA.defaultProps = {
	height: 150,
	width: 204,
};
addPropertyControls(FramerPMvn2toMA, {
	variant: {
		options: ["ono3D8Lsa", "ZUd9LxhGg"],
		optionTitles: ["ConfirmationRequest", "Confirmed"],
		title: "Variant",
		type: ControlType.Enum,
	},
	TFHZ_QdnQ: {
		defaultValue:
			"Are you sure you would like to cancel this scheduled upload?",
		displayTextArea: false,
		title: "Question",
		type: ControlType.String,
	},
	Rn0tbIBHJ: {
		defaultValue: "Upload Cancelled",
		description: "",
		displayTextArea: false,
		title: "Message",
		type: ControlType.String,
	},
	G7QWmFrxx: {
		title: "Exit Click",
		type: ControlType.EventHandler,
	},
	PC5Ghwrec: {
		defaultValue: "rgb(255, 149, 140)",
		title: "ConfirmationColor",
		type: ControlType.Color,
	},
	WnTLDTmKT: {
		defaultValue: "NO",
		displayTextArea: false,
		title: "DECLINE TEXT",
		type: ControlType.String,
	},
	jhL6rJVje: {
		defaultValue: "YES",
		displayTextArea: false,
		title: "CONFIRMATIONTEXT",
		type: ControlType.String,
	},
});
addFonts(
	FramerPMvn2toMA,
	[
		{
			explicitInter: true,
			fonts: [
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange:
						"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
					url: "https://framerusercontent.com/assets/5vvr9Vy74if2I6bQbJvbw7SY1pQ.woff2",
					weight: "400",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
					url: "https://framerusercontent.com/assets/EOr0mi4hNtlgWNn9if640EZzXCo.woff2",
					weight: "400",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange: "U+1F00-1FFF",
					url: "https://framerusercontent.com/assets/Y9k9QrlZAqio88Klkmbd8VoMQc.woff2",
					weight: "400",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange: "U+0370-03FF",
					url: "https://framerusercontent.com/assets/OYrD2tBIBPvoJXiIHnLoOXnY9M.woff2",
					weight: "400",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange:
						"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
					url: "https://framerusercontent.com/assets/JeYwfuaPfZHQhEG8U5gtPDZ7WQ.woff2",
					weight: "400",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange:
						"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2070, U+2074-207E, U+2080-208E, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
					url: "https://framerusercontent.com/assets/GrgcKwrN6d3Uz8EwcLHZxwEfC4.woff2",
					weight: "400",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange:
						"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB",
					url: "https://framerusercontent.com/assets/b6Y37FthZeALduNqHicBT6FutY.woff2",
					weight: "400",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange:
						"U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
					url: "https://framerusercontent.com/assets/hyOgCu0Xnghbimh0pE8QTvtt2AU.woff2",
					weight: "600",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
					url: "https://framerusercontent.com/assets/NeGmSOXrPBfEFIy5YZeHq17LEDA.woff2",
					weight: "600",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange: "U+1F00-1FFF",
					url: "https://framerusercontent.com/assets/oYaAX5himiTPYuN8vLWnqBbfD2s.woff2",
					weight: "600",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange: "U+0370-03FF",
					url: "https://framerusercontent.com/assets/lEJLP4R0yuCaMCjSXYHtJw72M.woff2",
					weight: "600",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange:
						"U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
					url: "https://framerusercontent.com/assets/cRJyLNuTJR5jbyKzGi33wU9cqIQ.woff2",
					weight: "600",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange:
						"U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2070, U+2074-207E, U+2080-208E, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
					url: "https://framerusercontent.com/assets/yDtI2UI8XcEg1W2je9XPN3Noo.woff2",
					weight: "600",
				},
				{
					cssFamilyName: "Inter",
					source: "framer",
					style: "normal",
					uiFamilyName: "Inter",
					unicodeRange:
						"U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB",
					url: "https://framerusercontent.com/assets/A0Wcc7NgXMjUuFdquHDrIZpzZw0.woff2",
					weight: "600",
				},
			],
		},
	],
	{
		supportsExplicitInterCodegen: true,
	},
);

// virtual:confirmation-request
import { WithFramerBreakpoints } from "unframer";
import { jsx } from "react/jsx-runtime";
var locales = [];
var defaultResponsiveVariants = {
	base: "ono3D8Lsa",
};
/** @type {function(Props): any} */
function ComponentWithRoot({ locale, ...rest }) {
	return (
		<ContextProviders
			routes={routes}
			framerSiteId={
				"87f9c755347dad76fedd65c32355276920a85144cd0f57411ebe1b0bdf0c38db"
			}
			locale={locale}
			locales={locales}
		>
			{jsx(stdin_default, {
				...rest,
			})}
		</ContextProviders>
	);
}
/**
 * @type {import("unframer").UnframerBreakpoint}
 * Represents a responsive breakpoint for unframer.
 */

/**
 * @typedef VariantsMap
 * Partial record of UnframerBreakpoint to Props.variant, with a mandatory 'base' key.
 * { [key in UnframerBreakpoint]?: Props['variant'] } & { base: Props['variant'] }
 */

/**
 * Renders ConfirmationRequestFramerComponent for all breakpoints with a variants map. Variant prop is inferred per breakpoint.
 * @function
 * @param {Omit<Props, 'variant'> & {variants?: VariantsMap}} props
 * @returns {any}
 */
ComponentWithRoot.Responsive = ({ locale = "", ...rest }) => {
	return (
		<ContextProviders
			routes={routes}
			framerSiteId={
				"87f9c755347dad76fedd65c32355276920a85144cd0f57411ebe1b0bdf0c38db"
			}
			locale={locale}
			locales={locales}
		>
			<WithFramerBreakpoints
				Component={stdin_default}
				variants={defaultResponsiveVariants}
				{...rest}
			/>
		</ContextProviders>
	);
};
Object.assign(ComponentWithRoot, stdin_default);
var confirmation_request_default = ComponentWithRoot;
export { confirmation_request_default as default };
